import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './config/firebase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MenuManagement from './pages/MenuManagement';
import Orders from './pages/Orders';
import TableManagement from './pages/TableManagement';
import Analytics from './pages/Analytics';
import RestaurantSettings from './pages/RestaurantSettings';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route
        path="/dashboard"
        element={user ? <Dashboard /> : <Navigate to="/login" />}
      />
      <Route
        path="/menu"
        element={user ? <MenuManagement /> : <Navigate to="/login" />}
      />
      <Route
        path="/orders"
        element={user ? <Orders /> : <Navigate to="/login" />}
      />
      <Route
        path="/tables"
        element={user ? <TableManagement /> : <Navigate to="/login" />}
      />
      <Route
        path="/analytics"
        element={user ? <Analytics /> : <Navigate to="/login" />}
      />
      <Route
        path="/settings"
        element={user ? <RestaurantSettings /> : <Navigate to="/login" />}
      />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;
